<!-- <select class="form-control d-none d-md-block my-1" [(ngModel)]="selectedEvent">
  <option [value]="item.id" *ngFor="let item of eventList;trackBy:trackByIndex;">{{item.name}}</option>
</select> -->
<div class="table-responsive">
  <table class="table table-bordered">
      <thead>
          <tr>
              <th>matched bet</th>
              <th>odds</th>
              <th>stake</th>
              <th>date / time</th>
          </tr>
      </thead>
      <tbody>
          <tr [ngClass]="item.bet_type == 1 ? 'back' : 'lay'" *ngFor="let item of data.matched | filter : {'event_id-eq': selectedEvent}; trackBy:trackByIndex;">
            <td>{{item.runner_name}} {{item.market_type}} </td>
            <td>{{item.average_rate_matched | number}}</td>
            <td>{{item.stake_matched | number}}</td>
            <td>{{(item.matched_at_format ? item.matched_at_format : item.matched_at) | date :
                'dd/MM/YYYY hh:mm:ss a'}}</td>
          </tr>
          <tr [ngClass]="item.bet_type == 1 ? 'back' : 'lay'" *ngFor="let item of data.fancy | filter : {'event_id-eq': selectedEvent}; trackBy:trackByIndex;">
            <td>{{item.runner_name}} {{item.market_type}} </td>
            <td>{{item.price != 100 ? (item.rate | number)+'/'+(item.price | number) : item.average_rate_matched | number}}</td>
            <td>{{item.stake_matched | number}}</td>
            <td>{{(item.matched_at_format ? item.matched_at_format : item.matched_at) | date : 'dd/MM/YYYY hh:mm:ss a'}}</td>
          </tr>
      </tbody>
  </table>
</div>